import { Controller } from "@hotwired/stimulus";

/**
 * Disables targeted elements (e.g. buttons that navigate away or trigger a
 * separate action) once the form has unsaved changes, so users can't act on
 * stale data.
 *
 * Usage:
 *   <form data-controller="forms--dirty-tracking"
 *         data-action="input->forms--dirty-tracking#markDirty change->forms--dirty-tracking#markDirty">
 *     <button data-forms--dirty-tracking-target="disableOnDirty">...</button>
 *   </form>
 */
export default class extends Controller {
  static targets = ["disableOnDirty"];

  markDirty() {
    this.disableOnDirtyTargets.forEach((el) => {
      el.disabled = true;
    });
  }
}
